import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import InterviewService from "./interviewService";

export const getInterviews = createAsyncThunk("Interview/get-Interviews", async (thunkAPI) => {
  try {
    return await InterviewService.getInterviews();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createInterviews = createAsyncThunk(
  "Interview/create-Interviews",
  async (InterviewData, thunkAPI) => {
    try {
      return await InterviewService.createInterviews(InterviewData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAInterview = createAsyncThunk(
  "Interview/get-Interview",
  async (id, thunkAPI) => {
    try {
      return await InterviewService.getInterview(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAInterview = createAsyncThunk(
  "Interview/update-Interview",
  async (brand, thunkAPI) => {
    try {
      return await InterviewService.updateInterview(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAInterview = createAsyncThunk(
  "Interview/delete-Interview",
  async (id, thunkAPI) => {
    try {
      return await InterviewService.deleteInterview(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Interviews: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const InterviewSlice = createSlice({
  name: "Interview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInterviews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInterviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Interviews = action.payload.data;
      })
      .addCase(getInterviews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createInterviews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createInterviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdInterview = action.payload;
      })
      .addCase(createInterviews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getAInterview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAInterview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.interviewtitle = action.payload.data.title;
        state.interviewVideos = action.payload.data.videos[0];
        
      })
      .addCase(getAInterview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAInterview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAInterview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedInterview = action.payload;
        
       
      })
      .addCase(updateAInterview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAInterview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAInterview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedInterview = action.payload;
      })
      .addCase(deleteAInterview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default InterviewSlice.reducer;
